module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-10.31199b82.png";